/**
 * @description Extract number from string. If no number is found, return 0.
 * @param str - The string | number to extract the number from.
 * @param defaultValue - The default value to return if no number is found.
 */
export const extractNumber = (str: string | number, defaultValue = 0) => {
  const num = String(str).match(/\d+/g);
  return num ? Number(num.join('')) : defaultValue;
};
